<script setup lang="ts">
function removeElement(el: Element) {
  el?.remove();
}
</script>

<template>
  <Transition
    name="invitation-cover"
    appear
    @after-leave="removeElement"
  >
    <slot />
  </Transition>
</template>

<style>
.invitation-cover-leave-active {
  transition:
    opacity 280ms ease,
    transform 260ms cubic-bezier(0.22, 0.61, 0.36, 1);
}

.invitation-cover-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .invitation-cover-leave-active {
    transition: none !important;
  }
}
</style>
